/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Ref, UnwrapRef, watch } from '@nuxtjs/composition-api';

import IBiuroSzczegoly from '~/components/biura/types/IBiuroSzczegoly';
import IGoogleMapConfig from '~/components/map/types/mapConfig';
import IMarkersInnerState from '~/components/map/types/markersInnerState';

import getMarkerPosition from '../../marker/getMarkerPosition';

interface IFetchMarkersFromPropsParams {
  markersInnerState: UnwrapRef<IMarkersInnerState<IBiuroSzczegoly>>;
  config: IGoogleMapConfig;
  markers: Ref<IBiuroSzczegoly[]>;
}

const fetchMarkersFromStore = (params: IFetchMarkersFromPropsParams): void => {
  const { markersInnerState, config, markers } = params;

  watch(
    markers,
    (newValue) => {
      markersInnerState.markers = markers.value;
      markersInnerState.activeMarker = markers.value?.length ? markers.value[0] : undefined;
      config.position = markers.value?.length
        ? getMarkerPosition(markers.value[0])
        : {
          lat: 0,
          lng: 0,
        };
    },
    { immediate: true },
  );
};
export default fetchMarkersFromStore;
